import { createApp } from '@app/adapters/create-app'

import WorkflowReview from './../screens/workflow-review/components/workflow-review'
import extractEndpointParams from '@app/application/workflows/utils/extract-endpoint-params.ts'
import createStore from '@app/application/workflows/screens/workflow-review/store'

import './trigger'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-review']").each(function () {
    const data = this.dataset

    const reviewItems = JSON.parse(data.reviewItems)
    const initialItemsRange = JSON.parse(data.initialItemsRange)
    const compareData = JSON.parse(data.compareData)
    const tagCloud = JSON.parse(data.tagCloud)

    const { messageBusChannelName, messageBusLastId, batchSize } = data

    const endpointParams = extractEndpointParams({
      ledgerId: data.ledgerId,
      reviewItems,
    })

    const { compare: compareMode, ...compareLedgerData } = compareData

    const workflowReviewApp = createApp(WorkflowReview, {
      workflowId: data.workflowId,
      ledgerId: data.ledgerId,
      ledgerLabel: data.ledgerLabel,
      compareLedgerData,
      initialCompareMode: compareMode,
      initialItemsRange,
      initialReviewItems: reviewItems,
      messageBusChannelName,
      messageBusLastId,
      batchSize: parseInt(batchSize, 10),
      sidepaneFixed: data.sidepaneFixed === 'true',
      useAssistantChecks: data.useAssistantChecks === 'true',
    })

    workflowReviewApp.use(
      createStore(endpointParams, {
        tagCloud,
      })
    )

    workflowReviewApp.mount(this)
  })
})
